export default "__VITE_ASSET__C$JeSYr2__"